/* A busca que desce — [2026-08-29], item 4.1.

   🔴 OS CARTÕES NÃO SE DESENHAM AQUI. A primeira versão montava cartão em JS a
     partir do `/search/suggest.json` e ele viu de primeira: *"só o formato que
     está do modelo de base do tema e não do nosso modelo criado"*. O cartão da
     Éttore é Liquid — estrelas, pix, 4x, bolinhas, botão Comprar — e refazê-lo
     em JS seria o gêmeo que diverge, como os três mapas de cor.
   👉 Agora o HTML vem da ROTA DE SEÇÃO da Shopify:
     `/search?q=…&section_id=ettore-busca-grade`. O servidor devolve os cartões
     de verdade, e este arquivo só troca o pedaço.

   🪤 A LUPA CONTINUA SENDO UM LINK: sem JS ela leva para /search e a busca da
     loja funciona igual.
   🪤 DELEGAÇÃO NO DOCUMENT: o cabeçalho é reescrito pelo editor a cada mudança
     de setting, e ouvinte preso a elemento morre no primeiro redesenho. */
(function () {
  var painel = document.querySelector('[data-ebusca]');
  if (!painel) return;

  var campo  = painel.querySelector('[data-ebusca-campo]');
  var grade  = painel.querySelector('[data-ebusca-grade]');
  var titulo = painel.querySelector('[data-ebusca-tit]');
  var nada   = painel.querySelector('[data-ebusca-nada]');
  /* a grade de abertura veio pronta do Liquid: guardar para poder VOLTAR
     quando a pessoa apagar o que digitou, sem custar outra chamada */
  var abertura = grade ? grade.innerHTML : '';
  var tituloAbertura = titulo ? titulo.textContent : '';

  var timer = null, ultima = '', pedido = 0;

  function busca(q) {
    if (!q) {
      grade.innerHTML = abertura;
      titulo.textContent = tituloAbertura;
      nada.hidden = true;
      return;
    }
    var meu = ++pedido;
    fetch('/search?q=' + encodeURIComponent(q) + '&section_id=ettore-busca-grade',
          { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        /* 🪤 resposta atrasada de uma busca antiga sobrescreveria a atual */
        if (meu !== pedido) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cartoes = doc.querySelectorAll('.pc');
        grade.innerHTML = '';
        cartoes.forEach(function (c) { grade.appendChild(document.importNode(c, true)); });
        titulo.textContent = 'Resultados para “' + q + '”';
        titulo.hidden = false;
        nada.hidden = cartoes.length > 0;
      })
      .catch(function () { /* rede caiu: deixa o que já está na tela */ });
  }

  var voltaFoco = null;
  function abre(e) {
    if (e) e.preventDefault();
    voltaFoco = document.activeElement;
    painel.hidden = false;
    painel.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    /* [2026-09-16] a barra de abas do celular (e o WhatsApp) some enquanto a busca está aberta — o ettore-abas.css lê esta classe */
    document.documentElement.classList.add('ebusca-aberta');
    if (campo) { campo.value = ''; campo.focus(); }
    busca('');
  }
  function fecha() {
    painel.hidden = true;
    painel.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('ebusca-aberta');
    if (voltaFoco && voltaFoco.focus) voltaFoco.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('a.busca, [data-ebusca-abre]')) { abre(e); return; }
    if (e.target.closest('[data-ebusca-fecha]')) { fecha(); return; }
  });

  /* [2026-09-13] CICLO DE TAB DENTRO DO PAINEL — auditoria do Codex, ponto 11. O foco saía do painel
     aberto e chegava a controles encobertos (medido: 16 Tabs levavam ao botão de cupom da página de
     trás). Só os elementos VISÍVEIS entram no ciclo: os que estão em `display:none` não têm caixa. */
  function focaveis(cx) {
    var lista = cx.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(lista, function (el) { return el.getClientRects().length > 0; });
  }
  function ciclaTab(e, cx) {
    if (e.key !== 'Tab') return;
    var f = focaveis(cx);
    if (!f.length) { e.preventDefault(); return; }
    var i = f.indexOf(document.activeElement);
    if (e.shiftKey && (i <= 0)) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && (i === -1 || i === f.length - 1)) { e.preventDefault(); f[0].focus(); }
  }
  document.addEventListener('keydown', function (e) {
    if (painel.hidden) return;
    if (e.key === 'Escape') { fecha(); return; }
    ciclaTab(e, painel);
  });
  if (campo) {
    campo.addEventListener('input', function () {
      var q = campo.value.trim();
      ultima = q;
      clearTimeout(timer);
      /* 250ms: abaixo disso a loja recebe uma chamada por tecla digitada */
      timer = setTimeout(function () { busca(q); }, 250);
    });
  }
})();
